import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  AFFILIATES_APPROVED_PERMISSIONS,
  DOWNLOAD_AFFILIATES_REPORT_API_URL,
  DOWNLOAD_AFFILIATES_REPORT_MUTATION_KEY,
} from '../constants';

export default function useDownloadAffiliatesReportMutation(): IContextMutationResult<
  void,
  Error,
  IDownloadListReportPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [DOWNLOAD_AFFILIATES_REPORT_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      DOWNLOAD_AFFILIATES_REPORT_API_URL,
      payload,
      { permission: AFFILIATES_APPROVED_PERMISSIONS.DOWNLOAD_LIST_APPROVED },
    ),
  });
}
